import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';

//import {DateFormatInput} from 'material-ui-next-pickers'
import { TIME_SELECTION_CONTAINER } from '../../../../../constants/strings/StringsDashboard';
import CalendarIcon from '@material-ui/icons/CalendarToday';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './../../../../../Actions/Dashboard';


class RangeSelect extends Component {
    constructor(props) {
        super(props)
        this.ya = new Date()
        this.state = {
            date0: new Date(this.ya.getFullYear(), this.ya.getMonth(), this.ya.getDate()),
            date1: new Date(this.ya.getFullYear(), this.ya.getMonth(), this.ya.getDate())
        }
    }

    onChangeDate = (date, variable) => {
        let val = date.target.value.split('-');
        let resp = new Date(val[0], val[1] - 1, val[2]);
        this.setState({ [variable]: resp });
    }

    validateDates = () => {
        const dif = this.state.date1 - this.state.date0
        if (dif < 0) {
            alert('Fecha inicial es posterior a la fecha final')
        } else if (dif > 0) {
            this.props.actions.selectFilter({ id: this.ya.getTime(), value: this.setDateToString(this.state.date0) + ' - ' + this.setDateToString(this.state.date1) }, 'range')
        }
    }

    setDateToString = (date) => {
        return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
    }

    //Actualizacion develop
    render() {
        const { date0, date1 } = this.state;
        const fecha = (dato) => {
            var date = dato.toISOString().substr(0, 10);
            return date;
        }
        return (
            <>
                <Grid container style={{ textAlign: 'center' }} >
                    <Grid item xs={1} className="client-label" style={{ textAlign: 'center' }}>
                        {TIME_SELECTION_CONTAINER.FROM}:
                </Grid>
                    <Grid item xs={5} className="client-label" style={{ textAlign: 'center' }}>
                        <div>
                            <input type={'date'} className={"date client-date-picker"} onChange={(ev) => this.onChangeDate(ev, 'date0')} defaultValue={fecha(date0)}></input>
                            <CalendarIcon />
                        </div>
                    </Grid>
                    <Grid item xs={1} className="client-label" style={{ textAlign: 'center' }}>
                        {TIME_SELECTION_CONTAINER.TO}:
                </Grid>
                    <Grid item xs={5} className="client-label" style={{ textAlign: 'center' }} >
                        <div>
                            <input type={'date'} className={"date client-date-picker"} onChange={(ev) => this.onChangeDate(ev, 'date1')} defaultValue={fecha(date1)}></input>
                            <CalendarIcon style={{ float: 'rigth' }} />
                        </div>
                    </Grid>
                </Grid>
                <Grid container style={{ marginTop: '10px' }}>
                    <Grid item xs={10}></Grid>
                    <Grid item xs={1}>
                        <Button color="primary" variant="contained" aria-label="Add" onClick={this.validateDates} >
                            <AddIcon />
                        </Button>
                    </Grid>
                    <Grid item xs={1}></Grid>
                </Grid>
            </>
        )
    }
}

function mapDispathToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
    }
}
export default connect(null, mapDispathToProps)(RangeSelect);


